export const defaultSettings = {
  brand: {
    img_path_admin_header_logo: null,
    img_path_login_screen_logo: null,
    img_path_app_header_logo: null,
    color_app_background: "#ffffff",
    color_app_text: "#111111",
    color_accent: "#6E30F9",
    color_accent_hover: "#8B59FA",
    color_accent_text: "#FFFFFF",
    color_error: "#C95700",
    color_error_hover: "#EF6700",
    color_error_text: "#FFFFFF",
    color_success: "#6AE295",
    color_success_hover: "#97F8BA",
    color_success_text: "#30235B",
    color_disabled: "#9790AC",
    color_disabled_text: "#FFFFFF",
    color_breadcrumb_background: "#30235B",
    color_header: "#6E30F9",
    color_header_accent: "#8B59FA",
    color_header_text: "#FFFFFF",
    color_navigation: "#30235B",
    color_navigation_text: "#FFFFFF",
    color_chat_message_in: "#9790AC",
    color_chat_message_out: "#30235B",
    color_chat_text: "#FFFFFF",
    color_profile_notification: "#594F7B",
    color_profile_notification_text: "#FFFFFF",
    color_modal_gradient1: "#000000",
    color_modal_gradient2: "#6E30F9",
    color_modal_text: "#FFFFFF",
    color_login_background: "#8B59FA",
    color_login_background_text: "#111111",
    color_login_logo_background: "#6f687d",
    color_login_logo_background_text: "#ffffff",
    img_path_login_background: null,
    img_path_email_header: null,
  },
  email: {
    text_from_name: "Belong",
    text_signature: "Belong",
    email_from_address: "noreply@belongmembership.com",
    email_support: "support@wearesweet.co.uk",
    text_platform_name: "Belong",
  },
  global_wording: {
    app_name: "Belong",
    zone_members: "Members Zone",
    zone_admin: "Admin Zone",
    entity_members: "Member",
    section_chat: "Chat",
    section_latest: "Latest",
    section_registration: "Registration",
    section_register: "Register",
    section_drive: "Drive",
    section_calendar: "Calendar",
    misc_registration: "Registration",
    misc_profile: "Profile",
    misc_picture: "Picture",
    misc_admins: "Admin(s)",
    misc_channel: "Channel",
  },
  sponsor: {
    name: null,
    url_website: null,
    img_path_header_logo: null,
    img_path_loading_screen: null,
    seconds_loading: 2,
  },
  miscellaneous: {
    enable_news_truncate_button: "false",
    google_analytics_measurement_id: null,
  },
};
